import { PropsWithChildren } from "react";
import { Account, SubmissionType } from "../../generated/graphql";
import { FlexColumn, FlexRow } from "../Common/__styles__/Layout";
import { AccountLogo } from "../Common/AccountLogo";
import { Body, Title } from "../Common/Typography";
import { ObjectInfoPanelLink } from "./__styles__/Submission";
import { VisibilityPill } from "./VisibilityPill";

type SubmissionHeaderProps = {
  account: Pick<Account, "logoUrl" | "name">;
  objectDisplay?: string;
  objectInfoPanelLink?: { pathname: string; search?: string };
  submissionType: Pick<SubmissionType, "name">;
  viewers: Array<string>;
};

const SubmissionHeader = ({
  account,
  objectDisplay,
  objectInfoPanelLink,
  submissionType,
  children,
  viewers,
}: PropsWithChildren<SubmissionHeaderProps>) => {
  const objectElement = objectDisplay ? (
    objectInfoPanelLink ? (
      <Body size="default" type="link">
        <ObjectInfoPanelLink to={objectInfoPanelLink} target="_blank">
          {objectDisplay}
        </ObjectInfoPanelLink>
      </Body>
    ) : (
      <Body size="default" type="regular">
        {objectDisplay}
      </Body>
    )
  ) : null;
  return (
    <FlexRow>
      <FlexColumn>
        {account.logoUrl && (
          <AccountLogo
            account={account}
            displayPrintOnly={true}
            style={{ marginRight: "16px" }}
          />
        )}
      </FlexColumn>
      <FlexColumn gap="m">
        <FlexColumn gap="s">
          <Title size="small" type="semiBold" color="contentPrimary">
            {submissionType.name}
          </Title>
          {objectElement}
          {children}
        </FlexColumn>
        <VisibilityPill viewers={viewers} />
      </FlexColumn>
    </FlexRow>
  );
};

export default SubmissionHeader;
